import React, { ReactElement } from 'react'
import {
	Row,
	Typography,
	ImageComponent,
	Icons,
} from '@copyrightagent/basic-components'
import { dark50 } from 'lib/Colors'
import { useStyle } from './style'

interface Image {
	image_id: string
	client_image_id: string
	photographer_name?: string
	photographer_id?: string
	supplier?: string
}

interface ImageRowProps {
	image: Image
	isSelected: boolean
	onSelect: (imageId: string) => void
}

export default function ImageRow({
	image,
	isSelected,
	onSelect,
}: ImageRowProps): ReactElement {
	const classes = useStyle()

	const handlePreview = () => {
		const url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PREFIX}/images/${image.image_id}/1280`
		window.open(url, '_blank')
	}

	const getThumbnailUrl = () => {
		return `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PREFIX}/images/${image.image_id}/200x200`
	}

	return (
		<div className={classes.root} onClick={() => onSelect(image.image_id)}>
			<Row
				className={`${classes.imageRow} ${
					isSelected ? classes.imageRowSelected : ''
				}`}
			>
				{/* Thumbnail */}
				{getThumbnailUrl() ? (
					<ImageComponent
						className={classes.thumbnail}
						overlayClassName={classes.thumbnailOverlay}
						src={getThumbnailUrl()!}
						onPreview={handlePreview}
					/>
				) : (
					<div className={classes.placeholder}>
						<Icons.ImageIcon color={dark50} />
					</div>
				)}

				{/* Image ID and Photographer */}
				<Row
					style={{ flex: 1 }}
					className={classes.imageRowColumn}
					align="start"
				>
					<Row>
						<Typography className={classes.imageID}>
							Image ID: {image.client_image_id}
						</Typography>
					</Row>
					{image.photographer_name && (
						<Row>
							<Typography variant="body2" className={classes.columnTitle}>
								Photographer: {image.photographer_name}
							</Typography>
						</Row>
					)}
				</Row>
			</Row>
		</div>
	)
}
